<template>
  <v-sheet>
    <base-grid
      :items="learningItems"
      :imageUrls="imageUrls"
      v-on:grid:badge:click="
        $router.push({
          name: 'learningItemMentor',
          params: { id: $event.id }
        })
      "
      gridId="js-learning-items-grid"
    />
  </v-sheet>
</template>
<script>
import BaseGrid from "@/components/BaseGrid"

export default {
  components: {
    BaseGrid
  },
  props: {
    courseId: { type: Number }
  },
  computed: {
    learningItems() {
      let course = this.$store.getters["courses/getCourseById"](this.courseId)
      return course ? course.learning_items : []
    },
    imageUrls() {
      return this.learningItems.map(el => el.badge_url)
    }
  }
}
</script>
